import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.flat-map.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue";
import { useRoutesStore } from '@/store/modules/routes';
import { useSettingsStore } from '@/store/modules/settings';
import variables from '@vab/styles/variables/variables.module.scss';
import { defaultOpeneds, uniqueOpened } from '@/config';

import { storeToRefs } from 'pinia';
import { computed } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    layout: {
      type: String,
      default: 'vertical'
    }
  },
  setup(__props) {
    const props = __props;
    const settingsStore = useSettingsStore();
    const {
      collapse
    } = storeToRefs(settingsStore);
    const routesStore = useRoutesStore();
    const {
      getRoutes: routes,
      getActiveMenu: activeMenu,
      getPartialRoutes: partialRoutes
    } = storeToRefs(routesStore);
    const handleRoutes = computed(() => {
      return props.layout === 'comprehensive' ? partialRoutes.value : routes.value.flatMap(route => route.meta.levelHidden && route.children ? [...route.children] : route);
    });
    return (_ctx, _cache) => {
      const _component_vab_logo = _resolveComponent("vab-logo");
      const _component_vab_menu = _resolveComponent("vab-menu");
      const _component_el_menu = _resolveComponent("el-menu");
      const _component_el_scrollbar = _resolveComponent("el-scrollbar");
      return _openBlock(), _createBlock(_component_el_scrollbar, {
        class: _normalizeClass(["vab-side-bar", {
          'is-collapse': _unref(collapse),
          'side-bar-common': __props.layout === 'common'
        }])
      }, {
        default: _withCtx(() => [__props.layout === 'vertical' || __props.layout === 'comprehensive' || __props.layout === 'float' ? (_openBlock(), _createBlock(_component_vab_logo, {
          key: 0
        })) : _createCommentVNode("", true), _createVNode(_component_el_menu, {
          "active-text-color": _unref(variables)['menu-color-active'],
          "background-color": _unref(variables)['menu-background'],
          collapse: _unref(collapse),
          "collapse-transition": false,
          "default-active": _unref(activeMenu).data,
          "default-openeds": _unref(defaultOpeneds),
          "menu-trigger": "click",
          mode: "vertical",
          "text-color": _unref(variables)['menu-color'],
          "unique-opened": _unref(uniqueOpened)
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(handleRoutes), (item, index) => {
            return _openBlock(), _createElementBlock(_Fragment, {
              key: index + item.name
            }, [!item.meta.hidden ? (_openBlock(), _createBlock(_component_vab_menu, {
              key: 0,
              item: item
            }, null, 8, ["item"])) : _createCommentVNode("", true)], 64);
          }), 128))]),
          _: 1
        }, 8, ["active-text-color", "background-color", "collapse", "default-active", "default-openeds", "text-color", "unique-opened"])]),
        _: 1
      }, 8, ["class"]);
    };
  }
});